(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-menu-content"] && !Shopify.designMode) return;
  try {
    
  class MegaMenuContent {
    constructor(element) {
      this.element = element;
      this.menuItem = element.dataset.menuItem;
      this.hoverTimeout = null;
      this.header = document.querySelector('.header') || document.querySelector('header');
      this.init();
    }

    init() {
      if (!this.header) return;

      const width = this.element.dataset.width || 'full';
      const customWidth = this.element.dataset.customWidth || '1200px';
      const horizontalAlignment = this.element.dataset.horizontalAlignment || 'automatic';
      const alignmentReference = this.element.dataset.alignmentReference || 'container';
      const preventOverflow = this.element.dataset.preventOverflow === 'true';
      const showCaret = this.element.dataset.showCaret === 'true';

      // Buscar todos los ítems del menú de navegación que coincidan con el título
      const headerMenuItems = Array.from(
        this.header.querySelectorAll('nav .list-menu > li.tree-menu, nav > ul > li.tree-menu')
      ).filter((item) => {
        const linkText = item.querySelector('a span')?.textContent.trim()
          || item.querySelector('a')?.textContent.trim();
        return linkText === this.menuItem;
      });

      if (headerMenuItems.length === 0) {
        this.element.style.display = 'none';
        return;
      }

      // Marcar ítems con la clase has-mega-menu para ocultar dropdown nativo
      headerMenuItems.forEach((item) => {
        item.classList.add('has-mega-menu');
        if (showCaret) {
          const link = item.querySelector('a');
          if (link && !link.querySelector('.mega-menu-caret')) {
            link.style.display = 'inline-flex';
            link.style.alignItems = 'center';
            link.style.gap = '0.25em';
            const caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            caret.setAttribute('class', 'mega-menu-caret');
            caret.setAttribute('viewBox', '0 0 20 20');
            caret.setAttribute('fill', 'currentColor');
            caret.setAttribute('aria-hidden', 'true');
            caret.innerHTML = '<path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />';
            link.appendChild(caret);
          }
        }
      });

      // Eliminar cualquier clon previo
      const existingClone = document.querySelector(`.mega-menu-clone[data-menu-item-clone="${this.menuItem}"]`);
      if (existingClone) existingClone.remove();

      // Crear clon y añadirlo al body
      const clone = this.element.cloneNode(true);
      clone.classList.add('mega-menu-clone');
      clone.dataset.menuItemClone = this.menuItem;
      document.body.appendChild(clone);

      // Inicializar toggles de submenús
      this.initSubmenuToggles(clone);
      this.initLinkInteractions(clone, headerMenuItems);

      // Actualizar posición al hacer scroll/resize
      const handleUpdate = () => {
        if (!clone.isConnected) {
          window.removeEventListener('scroll', handleUpdate);
          window.removeEventListener('resize', handleUpdate);
          return;
        }
        if (clone.classList.contains('is-active')) {
          const activeItem = headerMenuItems.find((item) => item.classList.contains('is-open'))
            || headerMenuItems[0];
          if (activeItem) {
            const positionConfig = this.calculatePosition({
              width, customWidth, horizontalAlignment, alignmentReference, preventOverflow, item: activeItem, clone,
            });
            this.applyPositioning(clone, activeItem, positionConfig);
          }
        }
      };
      window.addEventListener('scroll', handleUpdate, { passive: true });
      window.addEventListener('resize', handleUpdate, { passive: true });

      // Función para abrir/cerrar (modo click)
      const toggleMenu = (item, forceClose = false) => {
        const isActive = clone.classList.contains('is-active');
        if (forceClose || isActive) {
          clone.classList.remove('is-active');
          item.classList.remove('is-open');
        } else {
          // Cerrar otros mega menus activos
          document.querySelectorAll('.mega-menu-content.is-active, .mega-menu-clone.is-active').forEach((menu) => {
            if (menu !== clone) menu.classList.remove('is-active');
          });
          // Cerrar dropdowns nativos abiertos
          document.querySelectorAll('.tree-menu.is-open').forEach((mi) => mi.classList.remove('is-open'));

          const positionConfig = this.calculatePosition({
            width, customWidth, horizontalAlignment, alignmentReference, preventOverflow, item, clone,
          });
          this.applyPositioning(clone, item, positionConfig);
          clone.classList.add('is-active');
          item.classList.add('is-open');
        }
      };

      // Configurar eventos en cada ítem del menú
      headerMenuItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          clearTimeout(this.hoverTimeout);
          const positionConfig = this.calculatePosition({
            width, customWidth, horizontalAlignment, alignmentReference, preventOverflow, item, clone,
          });
          this.applyPositioning(clone, item, positionConfig);
          clone.classList.add('is-active');
          item.classList.add('is-open');
        });

        item.addEventListener('mouseleave', () => {
          this.hoverTimeout = setTimeout(() => {
            clone.classList.remove('is-active');
            item.classList.remove('is-open');
          }, 100);
        });
      });

      // Mantener el menú abierto cuando el cursor entra al clon
      clone.addEventListener('mouseenter', () => clearTimeout(this.hoverTimeout));
      clone.addEventListener('mouseleave', () => {
        this.hoverTimeout = setTimeout(() => {
          clone.classList.remove('is-active');
          headerMenuItems.forEach((item) => item.classList.remove('is-open'));
        }, 100);
      });

      // Cerrar con Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && clone.classList.contains('is-active')) {
          clone.classList.remove('is-active');
          headerMenuItems.forEach((item) => item.classList.remove('is-open'));
        }
      });

      // Ocultar el elemento original (el clon en body es el que se muestra)
      this.element.style.display = 'none';
    }

    calculatePosition({ width, customWidth, horizontalAlignment, alignmentReference, preventOverflow, item, clone }) {
      let widthConfig = {};
      switch (width) {
        case 'full':
          widthConfig = { width: '100%', maxWidth: '100dvw', minWidth: null };
          break;
        case 'container':
          widthConfig = { width: 'calc(var(--container-width, 1400px) - 3rem)', maxWidth: 'calc(100% - 3rem)', minWidth: null };
          break;
        case 'large':
          widthConfig = { width: '1400px', maxWidth: '95dvw', minWidth: null };
          break;
        case 'medium':
          widthConfig = { width: '900px', maxWidth: '90dvw', minWidth: null };
          break;
        case 'small':
          widthConfig = { width: '600px', maxWidth: '85dvw', minWidth: null };
          break;
        case 'fit':
          widthConfig = { width: 'max-content', maxWidth: '90dvw', minWidth: '400px' };
          break;
        case 'custom':
          widthConfig = { width: customWidth, maxWidth: '95dvw', minWidth: null };
          break;
        default:
          widthConfig = { width: '100%', maxWidth: '100dvw', minWidth: null };
      }

      if (width === 'container') {
        return { ...widthConfig, alignment: 'center', reference: 'container', preventOverflow: false };
      }

      if (horizontalAlignment === 'automatic') {
        if (width === 'full') {
          return { ...widthConfig, alignment: 'center', reference: 'container', preventOverflow };
        }
        return { ...widthConfig, alignment: 'center', reference: 'container', preventOverflow };
      }

      return { ...widthConfig, alignment: horizontalAlignment, reference: alignmentReference, preventOverflow };
    }

    applyPositioning(clone, item, config) {
      const { width, maxWidth, minWidth, alignment, reference, preventOverflow } = config;
      const isFull = width === '100%';
      const headerRect = this.header.getBoundingClientRect();

      if (isFull) {
        clone.classList.add('mega-menu-content--full-width');
      } else {
        clone.classList.remove('mega-menu-content--full-width');
      }

      clone.style.position = 'fixed';
      clone.style.zIndex = '11000';
      clone.style.top = `${headerRect.bottom}px`;
      clone.style.maxHeight = `calc(100dvh - ${headerRect.bottom}px)`;

      if (!isFull) {
        clone.style.width = width;
        clone.style.maxWidth = maxWidth;
        if (minWidth) clone.style.minWidth = minWidth;
      }

      let leftValue = '0';
      let rightValue = 'auto';
      let transformValue = '';

      if (isFull) {
        leftValue = '0';
        rightValue = '0';
        transformValue = 'none';
      } else if (reference === 'container') {
        const containerRect = this.header.getBoundingClientRect();
        if (alignment === 'left') {
          leftValue = `${containerRect.left}px`;
        } else if (alignment === 'right') {
          leftValue = 'auto';
          rightValue = `${window.innerWidth - containerRect.right}px`;
        } else {
          // center
          leftValue = `${containerRect.left + containerRect.width / 2}px`;
          transformValue = 'translateX(-50%)';
        }
      } else {
        // reference === 'parent'
        const itemRect = item.getBoundingClientRect();
        if (alignment === 'left') {
          leftValue = `${itemRect.left}px`;
        } else if (alignment === 'right') {
          leftValue = 'auto';
          rightValue = `${window.innerWidth - itemRect.right}px`;
        } else {
          leftValue = `${itemRect.left + itemRect.width / 2}px`;
          transformValue = 'translateX(-50%)';
        }
      }

      // Aplicar sin transición (para posicionamiento instantáneo antes de hacer visible)
      const isVisible = clone.classList.contains('is-active');
      if (!isVisible) {
        clone.style.transition = 'none';
      }

      clone.style.setProperty('--mega-menu-left', leftValue);
      clone.style.setProperty('--mega-menu-right', rightValue);
      clone.style.setProperty('--mega-menu-transform', transformValue);

      if (!isVisible) {
        clone.offsetHeight; // force reflow
        clone.style.transition = '';
      }

      // Overflow prevention
      if (preventOverflow && !isFull) {
        requestAnimationFrame(() => {
          const cloneRect = clone.getBoundingClientRect();
          const MARGIN = 20;
          const containerRect = this.header.getBoundingClientRect();

          if (reference === 'container') {
            if (cloneRect.right > containerRect.right) {
              const overflow = cloneRect.right - containerRect.right;
              clone.style.setProperty('--mega-menu-left', `${parseFloat(leftValue) - overflow - MARGIN}px`);
            }
            if (cloneRect.left < containerRect.left) {
              const overflow = containerRect.left - cloneRect.left;
              clone.style.setProperty('--mega-menu-left', `${parseFloat(leftValue) + overflow + MARGIN}px`);
            }
          } else {
            if (cloneRect.right > window.innerWidth - MARGIN) {
              const overflow = cloneRect.right - (window.innerWidth - MARGIN);
              clone.style.setProperty('--mega-menu-left', `${parseFloat(leftValue) - overflow}px`);
              if (alignment === 'center') clone.style.setProperty('--mega-menu-transform', 'none');
            }
            if (cloneRect.left < MARGIN) {
              clone.style.setProperty('--mega-menu-left', `${MARGIN}px`);
              clone.style.setProperty('--mega-menu-transform', 'none');
            }
          }
        });
      }
    }

    initSubmenuToggles(container) {
      container.querySelectorAll('[data-submenu-toggle]').forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          const listItem = button.closest('li');
          if (!listItem) return;
          const submenu = listItem.querySelector('[data-submenu-content]');
          if (!submenu) return;

          const isCollapsed = submenu.classList.contains('mega-menu-content__list--collapsed');

          if (isCollapsed) {
            submenu.classList.remove('mega-menu-content__list--collapsed');
            submenu.classList.add('mega-menu-content__list--expanded');
            submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            button.closest('.mega-menu-content__toggle, [data-submenu-toggle]')
              ?.classList.add('is-expanded');
            // Liberar max-height tras la animación
            setTimeout(() => {
              if (submenu.classList.contains('mega-menu-content__list--expanded')) {
                submenu.style.maxHeight = '1000px';
              }
            }, 400);
          } else {
            submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            submenu.offsetHeight; // force reflow
            submenu.classList.add('mega-menu-content__list--collapsed');
            submenu.classList.remove('mega-menu-content__list--expanded');
            submenu.style.maxHeight = '0';
            button.closest('.mega-menu-content__toggle, [data-submenu-toggle]')
              ?.classList.remove('is-expanded');
          }
        });
      });
    }

    initLinkInteractions(container, headerItems) {
      container.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          if (link.hasAttribute('data-submenu-toggle')) return;
          container.classList.remove('is-active');
          headerItems.forEach((item) => item.classList.remove('is-open'));
        });
      });
    }
  }

  function initMegaMenus() {
    document.querySelectorAll('.mega-menu-content:not([data-mega-menu-initialized])').forEach((menu) => {
      menu.setAttribute('data-mega-menu-initialized', 'true');
      new MegaMenuContent(menu);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenus);
  } else {
    initMegaMenus();
  }

  window.addEventListener('load', initMegaMenus);

  } catch(e) { console.error(e); }
})();
})();
